import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CaseResearch from './CaseResearch';
import LegalResearchTab from './LegalResearchTab';
import JurisdictionsTab from './JurisdictionsTab';

const ResearchDashboard = () => {
  const [activeTab, setActiveTab] = useState('ai-research');
  const location = useLocation();

  // Check if we have case_id and initialTab in location state (from navigation)
  useEffect(() => {
    if (location.state) {
      const { initialTab } = location.state;
      // Only set tab if it's one of the valid tabs (history tab has been removed)
      if (initialTab && ['ai-research', 'case-research', 'jurisdictions'].includes(initialTab)) {
        setActiveTab(initialTab);
      }
    }
  }, [location]);

  return (
    <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6">
      <div className="mb-4 sm:mb-8">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">Legal Research</h1>
        <p className="mt-1 sm:mt-2 text-sm sm:text-base text-gray-600 dark:text-gray-300">
          Use AI-powered tools to enhance your legal research and document analysis.
        </p>
      </div>

      {/* Research Navigation Tabs */}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-4 sm:space-x-8 overflow-x-auto scrollbar-thin">
          <button
            onClick={() => setActiveTab('ai-research')}
            className={`${activeTab === 'ai-research'
              ? 'border-primary-500 text-primary-600 dark:text-primary-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
              } whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm`}
          >
            AI Legal Research
          </button>
          <button
            onClick={() => setActiveTab('case-research')}
            className={`${activeTab === 'case-research'
              ? 'border-primary-500 text-primary-600 dark:text-primary-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
              } whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Case-Based Research
          </button>
          <button
            onClick={() => setActiveTab('jurisdictions')}
            className={`${activeTab === 'jurisdictions'
              ? 'border-primary-500 text-primary-600 dark:text-primary-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
              } whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Jurisdictions
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-4 sm:mt-6">
        {activeTab === 'ai-research' && <LegalResearchTab />}
        {activeTab === 'case-research' && <CaseResearch />}
        {activeTab === 'jurisdictions' && <JurisdictionsTab />}
      </div>
    </div>
  );
};

export default ResearchDashboard;
